"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var bankCard_1 = require("../../model/bankCard");
var service_1 = require("../../../library/base/service");
var FinancialList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(FinancialList, _super);
    function FinancialList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '高端理财选择交易银行卡接口';
        _this.code = '101060';
        _this.desc = '高端理财选择交易银行卡接口';
        _this.requestParams = new bankCard_1.FinancialListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return FinancialList;
}(service_1.BaseService));
exports.FinancialList = FinancialList;
//# sourceMappingURL=financialList.js.map